const INVENTORY_PAGE = {
  datesAvailability: 'Disponibilidade de SKU',
  pageTitle: 'Estoque de Produtos',
  pageTitleGroupFilter: 'Estoque de Produtos - Grupos',
  categories: 'Categorias',
  title: 'Estoque e Preços',
  categoryPlaceholder: 'Categorias',
  selectedItemsMessage: 'itens',
  seeMoreProducts: 'Ver mais produtos',
  doFilter: 'Filtrar',
  modalCancel: 'Cancelar',
  modalSave: 'Salvar',
  actionsAccessorKey: 'actions',
  actionsHeader: 'Ações',
  zeIcon: 'Icone Ze Delivery',
  sellerIcon: 'Icone Loja',
  resetFilters: 'Limpar Filtros',
  productSearch: 'Busca de produtos',
  availability: 'Disponibilidade',
  boostYourProduct: 'Turbine seu produto',
  commonActive: 'Comum ativo',
  commonInactive: 'Comum inativo',
  scheduledActive: 'Programado ativo',
  scheduledInactive: 'Programado inativo',
  available: 'Disponível',
  unavailable: 'Indisponível',
  unavailableProducts: 'Produto com datas indisponíveis',
  unavailableTooltip: `Indisponível do dia:`,
  productNotFoundAltImg: 'Produto não encontrado',
  productNotFoundMessage: 'Ops, nenhum resultado encontrado para',
  emptyProductListMessage: 'Ops, nenhum resultado encontrado.',
  emptyFavoriteListMessage: 'Você ainda não favoritou nenhum produto.',
  emptySuggestedPortfolio: 'Ops, ainda não temos sugestões para sua região.',
  emptyIsBoostedProductListMessage:
    'Ops! Nenhum produto participante de campanhas Turbine no momento.',
  idealPortfolio: 'Portfólio ideal',
  groupInfoMessage:
    'Qualquer item dessa lista conta como Portfólio Ideal na categoria',
  product: 'Produto',
  promotionHeader: 'Promoção',
  category: 'Categoria',
  group: 'Grupo',
  period: 'Período',
  status: 'Status',
  currentStatus: 'Em vigor',
  nextDiscountsStatus: 'Próximos descontos',
  price: 'Preço',
  newPromotionInterestDialog: {
    title: 'Por que o Turbine está indisponível para este produto?',
    description:
      'O Zé ainda está testando esta funcionalidade. Gostaria de dar desconto neste produto? ',
    haveInterest: 'Qual desconto você gostaria de aplicar?',
    zePrice: 'Preço de venda no Zé Delivery',
    suggestedDiscount: 'Desconto sugerido',
    discountApply: 'Esta não é a aplicação do desconto',
    discountInputPlaceholder: 'Ex.: 1',
    optional: '(opcional)',
  },
  pricesGlossary: {
    title: 'O que significam os valores',
    zeDeliveryDescription:
      'Representa o valor vendido no app do Zé Delivery pela unidade daquele produto.',
    storeDescription:
      'É o valor que a sua loja recebe ao vender uma unidade do produto após comissão. Para produtos Ambev, é o valor que o consumidor paga.',
  },
  defaultPrice: 'Preço',
  select: 'Selecione',
  delete: 'Deletar',
  edit: 'Editar desconto',
  centerText: 'Promoções',
  promotionNotFoundMessage: 'Ops, não há promoções para este filtro.',
  currentPromotions: 'Promoções em vigor',
  futurePromotions: 'Próximas Promoções',
  commonOrders: 'Pedidos comuns',
  scheduledOrders: 'Programados',
  productCode: 'Código do produto',
  insertCode: 'Insira o código',
  codeOfProduct: 'Código de produto',
  produtReport: 'Contestar produto',
  othersFilter: 'Outros',
  productCodeTooltipMessage:
    'Adicione o código do produto do seu sistema para ativar a integração.',
  integrationTooltipInfo:
    'Copie o código do produto no sistema que você usa pra controlar seu estoque e cole aqui. Faça isso em todos os produtos que você quer que fiquem integrados com o Seu Zé.',
  productCodeTooltipContent:
    'Copie e cole aqui o código do produto que está no sistema. Faça isso em todos os produtos que você quer que fiquem integrados com o Seu Zé.',
  savedCode: 'Código do produto salvo!',
  removedCode: 'Código removido!',
  exceededCharactersError: 'O código do produto excedeu 20 caracteres!',
  genericError: 'Algo deu errado, tente novamente mais tarde.',
  hasProductCode: 'Com código do produto',
  hasntProductCode: 'Sem código do produto',
  lastDeactivatedTab: 'Últimos desativados',
  lastUpdatedAt: 'Última atualização da lista:',
  isBoostedProductTab: 'Turbine seu produto',
  allProductsTab: 'Todos os produtos',
  favoritesTab: 'Favoritos',
  unavailableDaysWeekTab: 'Desativados na ultima semana',
  priceLabelsTab: {
    increased: 'Subiu o preço',
    decreased: 'Caiu o preço',
  },
  refreshButton: 'Atualizar',
  bannerSpecialList: {
    isIdealPortfolio: 'Portfolio ideal',
    bestSellersRegion: 'Mais vendidos da sua região',
    winesSellers: 'Vinhos vendidos na sua região',
    distilledSellers: 'Destilados vendidos na sua região',
    grocerySellers: 'Mercearia vendidos na sua região',
    snacksSellers: 'Petiscos vendidos na sua região',
    mostWantedSellers: 'Mais buscados pelos clientes',
    newProducts: 'Novos produtos na região',
    infoContainer: {
      recommendationTag: 'Recomendações do Zé',
      infoText: 'Deixe seu estoque mais competitivo',
    },
    errorText: 'Não foi possível carregar as recomendações',
  },
  newTag: 'Novo',
  promotion: {
    discountScheduledTooltipPrefix: 'Agendado para:',
    discountActiveTooltipPrefix: 'Ativo de:',
    columnTooltip:
      'Aplique descontos extras em produtos selecionados e tenha destaque na venda.',
    tooltipInfo: 'Desconto extra pago pela sua loja para acelerar suas vendas',
    switchTooltipInfo: 'Delete o agendamento para desativar esse desconto.',
    campaignTooltipInfo: 'Turbine ativo em campanha.',
    toggleLabel: 'Ativar desconto',
    activate: 'Ativar',
    discountCardTitle: '% desconto loja',
    discountScheduleCardTitle: (percentage: string) =>
      `Até ${percentage}% desconto`,
    updatePromotionSuccess: [
      'Desconto ativado com sucesso.',
      'Desconto desativado com sucesso.',
    ],
    unavailablePromotion: 'Desconto indisponível',
    iAmInterested: 'Tenho interesse',
    discountAvailable: 'Desconto disponível',
    discountActive: 'Desconto ativo',
    discountScheduled: 'Desconto agendado',
    activateCommon: 'Ativar comum',
    activateScheduled: 'Ativar programado',
    activateProduct: 'Ativar produto',
    discountTag: 'desconto Zé',
    tooltipTag:
      'Desconto dado pelo Zé. Sua loja não paga esse desconto, ele é reembolsado.',
    activateDiscount: 'Ativar desconto',
    scheduleDiscount: 'Agendar desconto',
    editDiscount: 'Editar desconto',
    saveSchedule: 'Salvar desconto',
    cancelSchedule: 'Cancelar desconto',
    deleteSchedule: 'Excluir desconto',
    editSchedule: 'Editar desconto',
  },
  promotionSchedule: {
    modalHeader: 'Configuração de desconto',
    modalFirstDescription:
      'Personalize seu desconto nos momentos mais importantes para sua loja',
    scheduleDescription:
      'Abaixo, você pode escolher os dias e horários em que seu produto estará ativo com desconto.',
    scheduleEditDescription:
      'Edite ou delete esse desconto através dos botões abaixo',
    scheduledDescription: 'Acompanhe seu desconto configurado',
    perCentDiscountOnProduct: (percentage: string) =>
      `${percentage} de desconto no produto`,
    storeReceives: (price: string) =>
      `Sua loja receberá ${price} por unidade vendida desse produto`,
    activeDays: ['Dias ativo', 'Dias ativos'],
    activePeriods: ['Períodos do dia ativo', 'Períodos do dia'],
    saveButton: 'Salvar desconto',
    savingDiscount: 'Salvando seu desconto',
    editButton: 'Editar desconto',
    deleteButton: 'Deletar desconto',
    allDays: 'Todos os dias',
    cancelButton: 'Cancelar',
    weekDays: {
      sunday: 'Domingo',
      monday: 'Segunda',
      tuesday: 'Terça',
      wednesday: 'Quarta',
      thursday: 'Quinta',
      friday: 'Sexta',
      saturday: 'Sábado',
    },
    allPeriods: 'Todos os períodos',
    periods: {
      morning: 'Manhã (6h - 11:59)',
      afternoon: 'Tarde (12h - 17:59)',
      evening: 'Noite (18h - 23:59)',
      lateNight: 'Madrugada (00h - 5:59)',
    },
    discountPicker: {
      titleMultiple: (min: string, max: string) =>
        `Escolha o valor do desconto, de ${min} a ${max}`,
      titleSingle: (value: string) => `Desconto de ${value}`,
    },
    discountCard: {
      approximateValue: '*Valor aproximado',
    },
    discountPeriodPicker: {
      title: 'Agende seu desconto',
      description:
        'Abaixo, você pode escolher os dias e horários em que seu produto estará ativo com desconto.',
      scheduleOptions: {
        always: {
          title: 'Todos os dias',
          description: 'Seg a Dom - 00h às 23:59',
        },
        weekdays: {
          title: 'De segunda a quinta',
          description: 'Seg a Qui - 00h às 23:59',
        },
        weekends: {
          title: 'Final de semana',
          description: 'Sex a Dom - 00h às 23:59',
        },
        super_friday: {
          title: '!!! SEXTOU !!!',
          description: 'Sexta-feira - 00h às 23:59',
        },
      },
    },
  },
  marketplaceFee: 'Marketplace',
  marketplaceFeeTooltip: {
    consumerPriceTitle: 'Preço Consumidor',
    consumerPriceContent:
      'Esse valor você já conhece! É o preço pelo qual o consumidor está pagando pelos produtos no Zé',
    pocPrice: 'Preço PDV',
    pocPriceContent:
      'Esse valor (o que tem o ícone da lojinha) é o valor que você irá receber após descontarmos o valor da comissão de marketplace. O cálculo é simples: preço consumidor - % comissão de marketplace',
  },
  shopIcon: 'ícone de loja',
  marketplaceFilter: 'Marketplace',
  activePocDiscount: 'Desconto loja ativo',
  inactivePocDiscount: 'Desconto loja inativo',
  searchedProducts: {
    title: 'Os mais vistos na sua região no último mês',
    banner: {
      title: ['Os mais', 'procurados!'],
      text: 'Saiba quais produtos são os mais visualizados na sua região!',
    },
    ranking: 'Ranking',
    product: 'Produto',
    price: 'Preço',
    available: 'Em estoque?',
    place: 'Lugar',
    searches: 'Visualizações',
    mostSearchedWord: 'Palavra mais procurada:',
  },
  reportProduct: {
    newReportTitle: 'Contestar produto',
    nextButton: 'Continuar',
    youSelected: 'Você selecionou',
    sendButton: 'Enviar',
    closeButton: 'Fechar',
    returnButton: 'Voltar',
    problemTitle: 'O que você deseja contestar?',
    optionError: 'Nenhuma opção disponível',
    problem: 'Você contestou',
    textAreaPlaceHolder: 'Digite aqui o problema',
    textProblemDetails: 'Detalhes do problema',
    currencyProblemDetails: 'Preço que você pagou pelo produto',
    currencyTitle: 'Qual valor praticado na sua região?',
    reportedProblemTitle: 'Você já contestou',
    successFeedbackHeader: 'Enviado com sucesso!',
    successFeedbackTitle: 'Agradecemos pelas informações.',
    successFeedbackText:
      'Nosso time está trabalhando para melhorar as condições de produtos na sua região.',
    reportError:
      'Não foi possível reportar o seu problema, tente novamente mais tarde.',
    alt: 'Cheers!',
    currentPrice: 'Preço de venda do Zé',
    reportHistory: {
      dateColumnHeader: 'Em',
      reasonColumnHeader: 'Motivo',
      suggestionColumnHeader: 'Sugeriu/Comentou',
    },
  },
  promotionInterestModal: {
    continue: 'Continuar',
    send: 'Enviar',
    sendSuggestion: 'Enviar sugestão',
    close: 'Fechar',
    iAmInterested: 'Tenho interesse',
    zeSellerPrice: 'Preço de venda do Zé',
    percentageInputLabel:
      'Qual percentual de desconto você gostaria de oferecer nesse produto?*',
    additionalInformationTitle: 'Essa não é a aplicação do desconto.',
    additionalInformationText:
      'Sua sugestão nos ajuda a entender e melhorar as ofertas de desconto.',
    registeredInterest: 'Interesse registrado',
    successFeedbackTitle: 'Agradecemos pelas informações',
    successFeedbackText:
      'Sua opinião ajuda nosso time a melhorar cada vez mais nossas ferramentas.',
    successFeedbackImageAlt: 'Cheers!',
    error: 'Não foi possível enviar seu interesse, tente novamente mais tarde.',
  },
  close: 'Fechar',
  goBack: 'Voltar',
  actions: 'Ações',
  mobileCardLabels: {
    deliveryType: 'Tipo de entrega',
    price: 'Preço',
    pdvPrice: 'Preço PDV',
    availability: 'Disponibilidade',
    discount: 'Desconto',
  },
  unavailableProduct: 'Produto indisponível',
  segment: {
    macroJourney: 'portfolio',
    microJourney: 'products',
    filters: 'Filters',
    specialListNames: {
      favorite: 'Favorite',
      unavailableDaysWeek: 'Unavailable Last Week',
      allProducts: 'All Products',
      increasedPrice: 'Increased Price',
      decreasedPrice: 'Decreased Price',
      isBoostedProduct: 'Is Boosted Product',
    },
    filterType: {
      brandFilter: 'BRAND_FILTER',
    },
    componentCategories: {
      button: 'Button',
      filterTab: 'Filter Tab',
      filterBanner: 'Filter Banner',
      filterBannerSpecialList: 'Filter Banner Special List',
      filterBar: 'Filter Bar',
      clearFilterButton: 'Clear Filter Button',
      favoriteButton: 'Favorite Button',
      toggleCampaign: 'Toggle campaign',
    },
    eventsName: {
      experimentTriggered: 'Manual Experiment Triggered',
      experimentConfirmed: 'Manual Experiment Conversion Confirmed',
      portfolioFilters: 'Portfolio Products Filters',
      availabilityToggleSelected: 'Product Availability Toggle Selected',
      productDisputeClicked: 'Product Dispute Clicked',
      moreOptionsClicked: 'More Options Clicked',
      productCodeClicked: 'Product Code Clicked',
      productFavorited: 'Products Favorited',
      discountAvailabilityViewed: 'Discount Availability Viewed',
      discountClicked: 'Discount Clicked',
      discountModalClicked: 'Discount Modal Clicked',
      inventoryModalClicked: 'Inventory Modal Clicked',
    },
    modalName: {
      discountInterest: 'Discount interest',
      discountScheduling: 'Discount scheduling',
      campaignProducts: 'Campaign Products',
    },
    campaigns: {
      componentNames: {
        activateCampaign: 'Ativar Campanha',
        campaignDetails: 'Detalhes da campanha',
        productsList: 'Lista de produtos',
        productsTab: 'Produtos',
        periodTab: 'Período',
      },
    },
    owner: 'Portfolio Seu Ze',
  },
  welcomeMessage: {
    reportProduct: {
      text: 'Não concorda com o preço ou condições de algum item do estoque?',
      link: 'Agora você pode contestar esse produto!',
    },
    categorizedBanners: {
      text: 'Novas listas de recomendações - Acesse e tenha o estoque mais competitivo.',
      link: 'Saiba Mais',
    },
  },
  infoBanner: {
    textBeforeBold: 'Produtos que ',
    textAfterBold:
      ' nos últimos 15 dias, incluindo produtos contestados na sua região.',
    increased: 'subiram o preço',
    decreased: 'cairam o preço',
  },
  categorizedBannersInfoModal: {
    title: 'Novas listas de recomendações do zé',
    content: {
      firstText:
        'Agora, além dos itens básicos do portfólio ideal que você precisa ter, disponibilizamos as listas de recomendações do Zé.',
      secondText:
        'Essa é uma facilidade para organizar e expandir seu estoque com produtos mais comprados pelos clientes da sua região de forma prática:',
      wordKey: 'Agora basta consultar as listas de cada categoria.',
      thirdText:
        'Sempre que produtos dessas categorias se destacarem localmente, eles aparecerão nessas listas. Se não houver itens mais vendidos, a categoria não será exibida.',
    },
    info: 'As listas são sugestões inteligentes e se atualizam com o tempo, então, para se manter conectado com as preferências dos seus clientes, fique sempre ligado aos produtos em destaque.',
    button: 'ok, fechar',
  },
  bannersMapping: {
    idealPortfolio: {
      title: 'Portfólio Ideal',
      description: 'Acompanhe aqui',
    },
    specialOffer: {
      title: 'Ofertas Especiais',
      description: 'ofereça descontos',
    },
    sellerPromoSpecialOffer: {
      title: 'Turbine e venda mais',
      description: 'ganhe incentivos',
    },
    newProducts: {
      title: 'Novos Produtos',
      description: 'acabaram de chegar',
    },
    mostWantedSellers: {
      title: 'Mais buscados',
      description: 'pelos clientes da região',
    },
    bestSellersRegion: {
      title: 'Mais vendidos',
      description: 'na sua região',
    },
    winesSellers: {
      title: 'Vinhos vendidos',
      description: 'na sua região',
    },
    distilledSellers: {
      title: 'Destilados vendidos',
      description: 'na sua região',
    },
    snackSellers: {
      title: 'Petiscos vendidos',
      description: 'na sua região',
    },
    grocerySellers: {
      title: 'Mercearia vendidos',
      description: 'na sua região',
    },
    moreCompetitiveRegion: {
      title: 'Fique mais competitivo',
      description: 'o que vende no seu raio',
    },
    complementCupOrders: {
      title: 'Foco na Copa',
      description: 'complemente seus pedidos',
    },
    mostSearchedProducts: {
      title: 'Mais buscados',
      description: 'em alta',
    },
  },
  products: 'produtos',
  brand: 'Marca',
  textualSearch: 'Busca textual',
  others: 'Outros',
  filteredBy: 'Filtrado por',
  clearAllFilters: 'Limpar todos',
  chopAvailabilityModal: {
    title: 'Disponibilidade de SKU',
    description:
      'Selecione o dia ou período em que o SKU ficará indisponível para o agendamento',
    warningText1: 'O limite de fechamento é de até 6 dias na mesma semana.',
    warningText2: 'É possível selecionar apenas um período por vez.',
  },

  // Filter bar
  filterBar: {
    filter: 'Filtrar',
    clearFilters: 'Remover todos',
    applyFilters: 'Aplicar',
    cancelFilters: 'Cancelar',
    search: 'Buscar',
    searchPlaceholder: 'Buscar por marca ou produto',
    mobileDescription: 'Filtre produtos ativos ou inativos na sua loja',
    mobileCategoriesDescription: 'Filtre produtos por categoria',
  },

  // On sale page
  onSale: {
    sellerCampaigns: {
      title: 'Turbine e venda mais',
    },
    commonOrders: 'Pedidos comuns',
    scheduledOrders: 'Pedidos agendados',
    header: {
      title: 'Promoções do Zé',
      description:
        'Venda com desconto Zé e impulsione produtos com reembolso garantido',
    },
    filters: {
      filtersTitle: 'Filtros',
      general: 'Geral:',
      byStatus: 'Por status:',
      favorites: 'Favoritos',
      active: 'Em vigor',
      coming: 'Próximos descontos',
      byActivation: 'Por ativação:',
      activeProducts: 'Produtos ativados',
      inactiveProducts: 'Produtos inativos',
      applyFilters: 'Aplicar',
      cancelFilters: 'Cancelar',
    },
  },
  brandsBanners: {
    previous: 'Voltar',
    next: 'Próximo',
    error: 'Não foi possível carregar os filtros de marca',
  },
  sellerCampaigns: {
    active: 'Ativar campanha',
    checkProducts: 'Confira produtos e descontos',
    giveDiscounts: 'Dê descontos em 1 clique',
    validFromTo: (startDate: string, endDate: string) =>
      `Válida entre ${startDate} a ${endDate}`,
    soon: 'Em breve',
    tags: {
      checkInventory: 'Confira seu estoque',
      onLive: 'Tá rolando!',
    },
    confirmationDialog: {
      title: 'Todos os produtos estão em estoque?',
      goBack: 'Voltar',
      yes: 'Sim, tenho tudo',
      productsActivated: 'Você acabou de ativar ',
      checkInventory:
        ' para começar a campanha. Confira se possui tudo em estoque antes de começar.',
      productsCount: (count: number) =>
        `${count} produto${count > 1 ? 's' : ''}`,
    },
    optoutDialog: {
      title: 'Campanha desativada! Descontos Turbine foram reativados',
      message:
        'Sua loja tinha descontos Turbine que estavam ativos antes da campanha? Fique tranquilo, reativamos eles automaticamente para você.',
      seeDiscounts: 'Ver descontos',
      understood: 'Entendi',
    },
    dialog: {
      productsTab: 'Produtos',
      periodTab: 'Período',
      footer:
        'Se você já tiver Turbine ativo, o desconto da campanha substitui o atual. Ao terminar a campanha, voltamos aos descontos que estavam antes.',
    },
    table: {
      turboPercent: '% Turbine',
      consumerPays: 'Consumidor paga',
      zeDiscount: 'Zé +',
      storeDiscount: 'Loja',
    },
    weeklyShiftCalendar: {
      shift: {
        morning: 'Manhã',
        afternoon: 'Tarde',
        night: 'Noite',
      },
      weekDays: {
        monday: 'Seg',
        tuesday: 'Ter',
        wednesday: 'Qua',
        thursday: 'Qui',
        friday: 'Sex',
        saturday: 'Sáb',
        sunday: 'Dom',
      },
      captionActive: 'Ativa',
      captionInactive: 'Inativa',
      weeklyActivation: 'Ativação ao longo da semana',
    },
    period: {
      validBetween: 'Válida entre:',
      and: 'e',
    },
    feedback: {
      success: {
        enabled: {
          message: (title: string, startDate: string, endDate: string) =>
            `${title} ativa!!! Você já está participando da campanha! Ela ficará ativa de ${startDate} até ${endDate}.`,
        },
        disabled: {
          message: (title: string) =>
            `A campanha ${title} foi desativada. Reponha o estoque e ative para continuar turbinando suas vendas.`,
        },
      },
      error: {
        message:
          'Erro ao ativar/inativar campanha. Tente novamente mais tarde.',
        campaignNotFound:
          'Esta campanha não foi encontrada. Tente novamente mais tarde.',
        campaignNotAvailable:
          'Esta campanha não está disponível no momento. Tente novamente mais tarde.',
        campaignAlreadyEnrolled: 'Você já está participando de outra campanha.',
      },
    },
  },
  productPrice: {
    zeTooltipText: 'Valor médio da unidade do produto no Ze Delivery.',
    storeTooltipText:
      'É o valor que a loja recebe ao vender uma unidade do produto após comissão. Para produtos Ambev, é o valor que o consumidor paga na maquininha.',
  },
  productBoostDiscounts: {
    title: 'Turbine este produto',
    subtitle: 'Acelere suas vendas',
    discountFees: 'Opcoes de desconto',
    scheduleOptions: {
      mondayToThursday: 'Segunda a quinta',
      friday: 'Sexta',
      all: 'Todos os dias',
    },
    status: {
      off: 'Desligado',
      scheduled: 'Agendado',
      activeDiscount: 'Desconto ativo',
      activeCampaign: 'Campanha ativa',
    },
  },
} as const

export default INVENTORY_PAGE
